<template>
  <div>
    <div
      class="row bg-light condense-header shadow-sm w-100 p-2"
      :style="{top: topOffset}"
      id="dropshipMfgHeader">
      <div class="col-12 text-center">
        <button 
          class="btn btn-sm btn-primary mt-2 ms-2 float-start"
          @click="back">
          <i class="fa fa-chevron-left"/>
          Back
        </button>
        <div class="row">
          <div
            class="col text-center">
            <DropshipMfgIndicator
              :mfg="mfg"
              :condense="condense"
              :showName="true"/>
          </div>
          <MinOrder
            class="d-none d-sm-block"
            :mfg="mfg"
            :company="company"
            :cartAmount="cartAmount"
            :cart="cart"
            :cartVendorMatch="cartVendorMatch"
            :dropshipCart="dropshipCart"
            :condense="condense"/>
          <PrepaidFreight
            class="d-none d-sm-block"
            :mfg="mfg"
            :company="company"
            :cartAmount="cartAmount"
            :cart="cart"
            :cartVendorMatch="cartVendorMatch"
            :dropshipCart="dropshipCart"
            :condense="condense"/>
        </div>
      </div>
      <FilterControls
        v-if="!loading"
        :key="mfg.mfg"
        class="mt-2"
        :products="products"
        :loading="loading"
        :exclude="['BranchFilter', 'ViewSwitcher', 'SubSearch']"/>
    </div>
  </div>
</template>

<script setup>
  import MinOrder from './MinOrder.vue';
  import PrepaidFreight from './PrepaidFreight.vue';
  import DropshipMfgIndicator from './DropshipMfgIndicator.vue';
  import FilterControls from '../../../../menus/views/FilterControls/FilterControls.vue';
  import { ref, watch, onMounted } from 'vue';

  // Initialize  
  const props = defineProps(['mfg', 'company', 'cartAmount', 'cart', 'cartVendorMatch', 'dropshipCart', 'condense', 'loading', 'products'])
  const emit = defineEmits(['back', 'setMfg'])

  // LifeCycle
  onMounted(()=>{
    setOffSet()
    window.addEventListener('resize', ()=>{
      setOffSet()
    })
  })

  // Data
  const selectedMfg = ref(null)
  const topOffset = ref(null)

  // Watcher
  watch(selectedMfg, (newVal)=>{
    if(newVal){
      emit('setMfg', newVal)
    }else{
      emit('setMfg', '')
    }
  })

  // Methods
  const back = ()=>{
    emit('back')
  }

  const setOffSet = ()=>{
    const navBar = document.getElementById('topNav').clientHeight
    topOffset.value = navBar + 'px'
  }

</script>

<style scoped>
  @media(min-width: 992px){
    .condense-header{
      left: -3px !important;
    }
  }
  .condense-header{
    border-bottom: 1px solid lightgray;
    height: auto;
    left: 12px;
    position: fixed;
    z-index: 1;
  }
</style>
